




import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataType } from '@/core/data/DataType';
import apexchart from 'vue-apexcharts';
import { FView } from '@/core/FView';
import { Common } from '@/core/Common';
import { EntranceVisitors } from '@/core/data/sets/computed/EntranceVisitors';
import { EnterExitDailyRecord } from '@/core/data/sets/EnterExitDailyRecord';

@Component ({
  components: {
      apexchart
  },
})
export default class extends Vue {
    @Prop() title!: string;
    @Prop() sourceDataSet!: EnterExitDailyRecord[];
    dataSet: EntranceVisitors[] | null = null;

    series = this.getSeries();
    chartOptions = {
        labels: this.getLabels(),
        title: {
            text: this.title,
            align: 'center',
            //offsetY: -10,
            style: {
                fontSize: '20px',
                fontFamily: 'FSElliotProBold',
            }
        },
    };

    getDataSet() {
        if (this.dataSet == null) {
            this.dataSet = EntranceVisitors.getEntrancesVisitors(this.sourceDataSet);
        }
        return this.dataSet;
    }

    getSeries() {
        return this.getDataSet().flatMap(r => r.passed);
    }

    getLabels() {
        return this.getDataSet().flatMap(r => r.name);
    }
}

